import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ApiDatabase from '../../../../../server';
import { useEffect, useState } from 'react';

const ModalInvoiceImportDetail = () => {
  const { toggle } = useModal();
  const { modalData } = UseContext();
  const token = localStorage.getItem('xsrfToken');
  const logId = modalData?.logId;

  const [log, setLog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!logId) return;
    setIsLoading(true);
    ApiDatabase.getInvoiceImportStatus(
      { token, id: logId },
      (data) => {
        setLog(data);
        setIsLoading(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') console.log(err);
        setIsLoading(false);
      }
    );
  }, [logId]);

  const actionLabel = log?.action === 'invoice_imported' ? 'Import' : 'Suppression';

  const statusLabel = (status) => {
    const map = {
      pending: 'En attente',
      processing: 'En cours',
      completed: 'Terminé',
      failed: 'Échoué',
      success: 'Succès',
      error: 'Erreur',
    };
    return map[status] || status;
  };

  const statusColor = (status) => {
    const map = {
      success: 'text-green-600',
      completed: 'text-green-600',
      error: 'text-red-600',
      failed: 'text-red-600',
      pending: 'text-yellow-600',
      processing: 'text-blue-600',
    };
    return map[status] || '';
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Détail de l'action
      </Modalheader>
      <ModalBody>
        {isLoading ? (
          <div className="animate-pulse space-y-3">
            <div className="h-4 w-1/3 bg-gray-200 rounded" />
            <div className="h-4 w-1/2 bg-gray-200 rounded" />
            <div className="h-20 bg-gray-100 rounded" />
          </div>
        ) : !log ? (
          <p className="text-sm text-gray-400">Aucun détail trouvé.</p>
        ) : (
          <div className="flex flex-col gap-4 text-sm">
            <div className="grid grid-cols-2 gap-2">
              <div>
                <span className="text-gray-500">Action :</span>{' '}
                <span className="font-medium">{actionLabel}</span>
              </div>
              <div>
                <span className="text-gray-500">Statut :</span>{' '}
                <span className={`font-medium ${statusColor(log.status)}`}>
                  {statusLabel(log.status)}
                </span>
              </div>
              <div>
                <span className="text-gray-500">Date :</span>{' '}
                {log.timestamp
                  ? new Date(log.timestamp).toLocaleString('fr-FR')
                  : '-'}
              </div>
              <div>
                <span className="text-gray-500">Admin :</span>{' '}
                {log.idEmployee?.firstname || ''}{' '}
                {log.idEmployee?.lastname || ''}
              </div>
            </div>

            <div className="grid grid-cols-4 gap-2 bg-gray-50 rounded p-3">
              <div className="text-center">
                <div className="text-lg font-semibold">
                  {log.summary?.total || 0}
                </div>
                <div className="text-xs text-gray-500">Total</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-semibold text-green-600">
                  {log.summary?.success || 0}
                </div>
                <div className="text-xs text-gray-500">Succès</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-semibold text-red-600">
                  {log.summary?.failed || 0}
                </div>
                <div className="text-xs text-gray-500">Échoué</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-semibold">
                  {log.summary?.totalAmount != null
                    ? `${Number(log.summary.totalAmount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
                    : '-'}
                </div>
                <div className="text-xs text-gray-500">Montant</div>
              </div>
            </div>

            {log.details && log.details.length > 0 && (
              <div className="border rounded">
                <table className="w-full text-sm">
                  <thead className="bg-gray-50 sticky top-0">
                    <tr>
                      <th className="p-2 text-left">N° Facture</th>
                      <th className="p-2 text-left">Entreprise</th>
                      <th className="p-2 text-right">Montant</th>
                      <th className="p-2 text-left">Résultat</th>
                    </tr>
                  </thead>
                  <tbody>
                    {log.details.map((d, i) => (
                      <tr
                        key={`${d.invoice_number}-${i}`}
                        className="border-t border-gray-100"
                      >
                        <td className="p-2">{d.invoice_number}</td>
                        <td className="p-2">{d.company_name}</td>
                        <td className="p-2 text-right">
                          {d.amount != null
                            ? `${Number(d.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
                            : '-'}
                        </td>
                        <td className="p-2">
                          <span
                            className={`font-medium ${statusColor(d.status)}`}
                          >
                            {statusLabel(d.status)}
                          </span>
                          {d.error && (
                            <div className="text-xs text-red-400 mt-0.5">
                              {d.error}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </ModalBody>
    </>
  );
};

export default ModalInvoiceImportDetail;
